import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.MARKERS}`;

async function fetchVisits(markerType, markerId) {
	try {
		
		const url = `${basePath}/active?markerTypeId=${markerType}`;

		let response = await api.get(url);

		let treated = errorHandling.handleResponse(
			response,
			"visitsService.fetchVisits"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "visitsService.fetchVisits");
		return null;
	}
};

async function createMarker(payload) {
    try {
        const url = `${basePath}`;

        let response = await api.post(url, payload);

		let treated = errorHandling.handleResponse(
			response,
			"visitsService.createMarker"
		);
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "visitsService.createMarker");
		return null;
	}
};

export const visitsService = {
	fetchVisits,
	createMarker
};
